import { Currencies } from "@orbital/games-frontend-library"
import floorFigure from "../../../configs/floorFigure"
import {
  checkForEmpty,
  checkForLengthAfterDot,
  checkOnlyDot,
  checkRegEx,
  checkStartWithDot,
} from "../../../helpers/checkers"
import { regexes } from "../../../helpers/regex"

export const handleAutoCashOutBlur = (
  bet: string,
  prec: number,
  handleAutoInputs: any,
  setCashOut: any,
  cashOutValue: any,
  key: string,
  value: string,
  autoPilotNumber: string,
  handleNotification: any,
  minbet: any,
  maxbet: any,
  currency: any,
) => {
  const minAutoCashout = 1.015

  if (+bet < 1 && +value < minAutoCashout) {
    return (
      handleAutoInputs(
        autoPilotNumber,
        key,
        floorFigure(minAutoCashout.toString(), prec),
      ),
      setCashOut(floorFigure(minAutoCashout.toString(), prec)),
      prec && handleNotification("CASHOUT AT SHOULD BE MORE THAN BET AMOUNT")
    )
  }

  if (value === "" || +value <= +bet) {
    return (
      handleAutoInputs(
        autoPilotNumber,
        key,
        floorFigure((+bet * 2).toString(), prec),
      ),
      setCashOut(floorFigure((+bet * 2).toString(), prec)),
      handleNotification("CASHOUT AT SHOULD BE MORE THAN BET AMOUNT")
    )
  }
  if (checkForEmpty(value) || checkOnlyDot(value)) {
    if (+bet < 1) {
      return (
        handleAutoInputs(
          autoPilotNumber,
          key,
          floorFigure(minAutoCashout.toString(), prec),
        ),
        setCashOut(floorFigure(minAutoCashout.toString(), prec))
      )
    }
    else if (bet === minbet) {
      return (
        handleAutoInputs(
          autoPilotNumber,
          key,
          (+bet * minAutoCashout).toFixed(prec),
        ),
        setCashOut((+bet * minAutoCashout).toFixed(prec))
      )
    }
    else {
      return (
        handleAutoInputs(
          autoPilotNumber,
          key,
          floorFigure((+bet * 2).toString(), prec),
        ),
        setCashOut(floorFigure((+bet * 2).toString(), prec)),
        handleNotification("CASHOUT AT SHOULD BE MORE THAN BET AMOUNT")
      )
    }
  }
  if (+value > Number(maxbet) * 5000) {
    handleNotification(
      `max CASHOUT AT value SHOULD BE less THAN ${floorFigure(
        (Number(maxbet) * 5000).toString(),
        prec,
      )}${Currencies[currency]}`,
    )
    return handleAutoInputs(
      autoPilotNumber,
      key,
      floorFigure((Number(maxbet) * 5000).toString(), prec),
      setCashOut(floorFigure((Number(maxbet) * 5000).toString(), prec)),
    )
  }
  if (checkStartWithDot(value)) {
    if (checkForLengthAfterDot(value, prec)) {
      return (
        handleAutoInputs(autoPilotNumber, key, floorFigure(cashOutValue, prec)),
        setCashOut(floorFigure(cashOutValue, prec))
      )
    } else {
      return (
        handleAutoInputs(autoPilotNumber, key, "0" + value),
        setCashOut("0" + value)
      )
    }
  }

  if (checkRegEx(value, regexes.onlyZeroes)) {
    return (
      handleAutoInputs(autoPilotNumber, key, floorFigure(value, prec)),
      setCashOut(floorFigure(value, prec))
    )
  }
  if (checkForLengthAfterDot(value, prec)) {
    if (+bet * minAutoCashout >= +value) {
      return (
        handleAutoInputs(
          autoPilotNumber,
          key,
          floorFigure((+bet * minAutoCashout).toString(), prec),
        ),
        setCashOut(floorFigure((+bet * minAutoCashout).toString(), prec))
      )
    } else {
      return (
        handleAutoInputs(autoPilotNumber, key, floorFigure(cashOutValue, prec)),
        setCashOut(floorFigure(cashOutValue, prec))
      )
    }
  }
  if (+bet * minAutoCashout >= +value) {
    return (
      handleAutoInputs(
        autoPilotNumber,
        key,
        (+bet * minAutoCashout).toString(),
        floorFigure((+bet * minAutoCashout).toString(), prec),
      ),
      setCashOut(floorFigure((+bet * minAutoCashout).toString(), prec))
    )
  }
  return (
    handleAutoInputs(autoPilotNumber, key, floorFigure(value, prec)),
    setCashOut(floorFigure(value, prec))
  )
}

// export const handleCashoutChange = (e: any, setStakeValue: any) => {
//   const value = e.target.value
//   if (checkRegEx(value, regexes.numbersDotComma)) {
//     setStakeValue(value.replace(/,/g, "."))
//   }
// }
export const handleCashoutChange = (e: any, setStakeValue: any, prec: number) => {
  const value = e.target.value;
  if (checkRegEx(value, regexes.numbersDotComma)) {
    // Replace commas with periods in the whole value
    let modifiedValue = value.replace(/,/g, ".");

    // Split the value into integer and decimal parts
    const [integerPart, decimalPart] = modifiedValue.split(".");

    // Limit the number of decimal places based on the `prec` parameter
    if (prec >= 0) {
      if (decimalPart) {
        modifiedValue = `${integerPart}.${decimalPart.slice(0, prec)}`;
      }
    }
    setStakeValue(modifiedValue);
  }
};